/** ES translations for Les Aiguilles Blanches */
const es: Record<string, string> = {
  subtitle: "Simulación de Pisapistas",
  startGame: "Empezar",
  resumeGame: "Continuar Partida",
  newGame: "Nueva Partida",
  // UNUSED continue: "Continuar",
  settings: "Ajustes",
  controls: "Controles",
  changelog: "Novedades",
  howToPlay: "Cómo Jugar",
  howToPlayMove: "{keys} o Flechas para mover",
  howToPlayMoveHybrid: "{keys}/Flechas o D-pad táctil",
  howToPlayGroom: "{groomKey} para preparar",
  howToPlayGroomHybrid: "{groomKey} o mantén el botón de preparar",
  fullscreen: "Pantalla completa",
  fullscreenHint: "Pulsa F para pantalla completa",
  exitFullscreen: "Salir pantalla completa",
  back: "Volver",
  backToGame: "Volver al juego",
  // UNUSED loading: "Cargando...",
  inputKeyboard: "✓ Teclado detectado",
  inputKeyboardOff: "✗ Sin teclado",
  inputTouch: "✓ Pantalla táctil detectada",
  inputTouchOff: "✗ Pantalla táctil no detectada",
  inputGamepad: "✓ Mando conectado",
  inputGamepadOff: "✗ Sin mando",
  updateAvailable: "Nueva versión disponible — toca para recargar",
  madeIn: "Hecho con ❄️ en Saboya",
  feedback: "Enviar comentarios",
  on: "✓ SÍ",
  off: "✗ NO",
  zoneClosed: "🚫 ZONA CERRADA",
  
  // Settings
  language: "Idioma",
  accessibility: "Accesibilidad",
  highContrast: "Alto Contraste",
  reducedMotion: "Menos Movimiento",
  showFps: "Mostrar FPS",
  showDebug: "Info de depuración",
  skiStyle: "Estilo",
  skiTricks: "Trucos",
  skiBestCombo: "Mejor combo",
  quitGame: "Salir del juego",
  display: "Pantalla",
  displayWindowed: "Ventana",
  displayFullscreen: "Pantalla completa",
  displayBorderless: "Sin bordes",
  colorblindMode: "Daltonismo",
  none: "Ninguno",
  deuteranopia: "Deuteran.",
  protanopia: "Protan.",
  tritanopia: "Tritan.",
  // UNUSED move: "Mover",
  moveUp: "Arriba",
  moveDown: "Abajo",
  moveLeft: "Izquierda",
  moveRight: "Derecha",
  groom: "Pisar",
  winch: "Cabrestante",
  pause: "Pausa",
  keyboard: "Teclado",
  clickToRebind: "Clic para cambiar",
  pressKey: "Pulsa una tecla...",
  pressGamepadButton: "Pulsa un botón del mando...",
  noGamepad: "Ningún mando conectado",
  gamepadButtons: "Mando",
  saved: "¡Guardado!",
  resetControls: "Restablecer",
  controlsReset: "¡Controles restablecidos!",
  movementSensitivity: "Sensibilidad",
  keyboardLayout: "Distribución",
  customBindings: "Personalizado",
  // UNUSED gamepadSupported: "Gamepad OK",
  touch: "Táctil",
  // UNUSED touchSupported: "Táctil OK",
  noGamepadConnected: "Ningún mando conectado",
  gamepadDiagnostic: "Test de mando",
  connectGamepadDiag: "Conecta un mando para probar",
  gamepadDiagButtons: "Botones",
  gamepadDiagSticks: "Palancas",
  gamepadDiagTriggers: "Gatillos",

  // Audio
  audio: "Audio",
  masterVolume: "Volumen general",
  musicVolume: "Música",
  sfxVolume: "Efectos de sonido",
  engineVolume: "Motor",
  voiceVolume: "Voz",
  ambienceVolume: "Ambiente",
  mute: "Silenciar",

  backgroundAudio: "Audio de fondo",
  // Gameplay
  bonus: "Bonus",
  skiMode: "Modo descenso",
  ski: "Esquí",
  snowboard: "Snowboard",
  random: "Aleatorio",
  skiIt: "¡A esquiar!",
  rideIt: "¡A surfear!",
  skiAgain: "¡Otra vez!",
  rideAgain: "¡Otra vez!",
  skiRunSpeed: "Velocidad",
  skiRunTime: "Tiempo",
  skiRunGates: "Puertas",
  
  // How to Play hints
  howToPlayMoveTouch: "Usa el D-pad virtual",
  howToPlayMoveGamepad: "Stick o D-pad para mover",
  howToPlayGroomTouch: "Mantén el botón de preparar",
  howToPlayGroomGamepad: "para preparar la nieve",
  howToPlayFuel: "¡Vigila el combustible y la resistencia!",
  howToPlayWinch: "{winchKey} junto a un poste para el cabrestante",
  howToPlayWinchTouch: "Mantén el botón cabrestante junto a un poste",
  howToPlayWinchGamepad: "junto a un poste para el cabrestante",
  howToPlayWinchHybrid: "{winchKey} o mantén el botón cabrestante junto a un poste",
  
  // Winch
  winchSnapped: "💥 ¡Cable roto!",
  winchAttached: "🔗 ¡Cabrestante enganchado! Mantén {winchKey} para asistencia.",
  winchActive: "CABRESTANTE",
  // UNUSED winchHint: "Pulsa {winchKey} cerca de un poste de anclaje numerado para usar el cabrestante",
  // UNUSED winchHintTouch: "Mantén 🔗 para el cabrestante",
  // UNUSED accessPath: "Camino de servicio",
  // UNUSED toPiste: "Hacia la pista",
  
  // Game
  // UNUSED paused: "Pausado",
  resume: "Reanudar",
  quitToMenu: "Volver al Menú",
  levelComplete: "¡Pista completada!",
  levelFailed: "Pista fallida",
  tryAgain: "Reintentar",
  coverage: "Cobertura",
  time: "Tiempo",
  // UNUSED target: "Objetivo",
  // UNUSED rating: "Puntuación",
  nextLevel: "Siguiente pista",
  // UNUSED replay: "Rejugar",
  // UNUSED pressContinue: "Pulsa Espacio o toca para continuar",
  pauseTitle: "⏸️ Pausa",
  restart: "Reiniciar",
  skipRun: "Saltar descenso",
  newRun: "Nueva pista",
  quit: "Salir",
  menu: "Menú",
  levelSelect: "Mapa de pistas",
  locked: "Cerrada",
   completeToUnlock: "Completa {name} para desbloquear",
  tutorial: "Escuela de esquí",
  timeUsed: "Tiempo usado",
  excellent: "¡Excelente!",
  good: "¡Bien hecho!",
  passed: "Aprobado",
  bonusFuel: "Combustible usado",
  bonusFlawless: "Primer intento",
  bonusSpeed: "Tiempo",
  bonusWinch: "Usos del cabrestante",
  bonusExplore: "Caminos explorados",
  bonusPrecision: "Calidad de preparación",
  retry: "Reintentar",
  gameComplete: "¡Juego completado!",
  viewCredits: "Ver créditos",
  creditsTitle: "¡Felicidades!",
  creditsSubtitle: "Has dominado Les Aiguilles Blanches",
  creditsCreatedBy: "Creado por",
  creditsDevelopedWith: "Desarrollado con",
  creditsArtDirection: "Dirección Artística",
  creditsRetroInspiration: "Un guiño a clásicos retro como SkiFree",
  creditsInspiredBy: "Inspirado por",
  creditsGroomers: "Los maquinistas de Saboya",
  creditsDedication: "Para los equipos nocturnos que preparan las pistas mientras dormimos",
  creditsThanks: "¡Gracias por jugar!",
  creditsSeeYou: "¡Hasta pronto en las pistas!",
  creditsLine: "Venga, chaval. El sol sale. La montaña está lista.",
  playAgain: "Jugar de nuevo",
  skipCredits: "Pulsa una tecla para saltar",
  fr: "Francés",
  
  // Levels - Tutorial step by step
  tutorialName: "Tutorial - Primeros Pasos",
  tutorialTask: "Aprende lo básico",
  prologueLine: "Las 4. La montaña es tuya. A trabajar.",
  prologueSkip: "Pulsa para continuar",
  tutorialIntro: "¡Bienvenido a Les Aiguilles Blanches!",
  skipTutorial: "⏭️ Saltando tutorial… Toca para repetirlo.",
  skipTutorialGamepad: "⏭️ Saltando tutorial… Pulsa para repetirlo.",
  tutorialWelcome: "🏔️ Soy Jean-Pierre, jefe pisador. Recorre la pista — usa {keys} o las flechas ↑↓←→.",
  tutorialWelcomeTouch: "🏔️ Soy Jean-Pierre, jefe pisador. Recorre la pista — usa el D-pad a la izquierda.",
  tutorialWelcomeGamepad: "🏔️ Soy Jean-Pierre, jefe pisador. Recorre la pista — usa el stick izquierdo o el D-pad.",
  // UNUSED     tutorialControls: "🎮 Para mover la pisapistas, usa {keys} o las flechas ↑↓←→.",
  // UNUSED     tutorialControlsTouch: "🎮 Para moverte, usa el D-pad ◀▲▼▶ a la izquierda.",
  // UNUSED     tutorialControlsGamepad: "🎮 Para moverte, usa el stick izquierdo o el D-pad.",
  // UNUSED     tutorialMove: "➡️ Venga, prueba. Muévete por la pista — hay que pisar toda la nieve blanca.",
  // UNUSED     tutorialGroomIntro: "✅ ¡Genial! Ahora aprendamos a pisar la nieve.",
  tutorialGroomAction: "❄️ Mantén {groomKey} mientras conduces para pisar la nieve. Ya verás, queda como una alfombra.",
  tutorialGroomActionTouch: "❄️ Mantén el botón de preparar a la derecha mientras conduces para pisar la nieve.",
  tutorialGroomActionGamepad: "❄️ Mantén {groomKey} mientras conduces para pisar la nieve. Ya verás, queda como una alfombra.",
  tutorialGroomGoal: "📊 ¡Así se hace! Pisa al menos el 60% antes de abrir. ¡Los esquiadores llegan!",
  // UNUSED   tutorialCoverage: "📊 ¿Ves? ¡La nieve se vuelve más lisa! ¡Sigue pisando!",
  // UNUSED   tutorialHUD: "📈 Mira el panel arriba: la barra roja es combustible, la verde resistencia, la blanca cobertura. ¡El reloj corre!",
  // UNUSED   tutorialGoal: "🎯 Hay que pisar al menos el 60% de la pista antes de abrir. ¡Los esquiadores llegan pronto!",
  // UNUSED tutorialFuel: "⛽ Cuidado, conducir gasta combustible. ¡En misiones, pásate por la gasolinera!",
  tutorialComplete: "🏆 ¡Bravo! Dominas lo básico. ¿Listo para tu primera misión en la Pista Verde?",
  level_marmottesName: "Pista Verde - Les Marmottes",
  level_marmottesTask: "Prepara la pista de principiantes",
  level_chamoisName: "Pista Azul - Le Chamois",
  level_chamoisTask: "Prepara antes de la apertura",
  level_airZoneName: "Snowpark - Air Zone",
  level_airZoneTask: "Prepara los módulos de freestyle",
  level_aigleName: "Pista Roja - L'Aigle",
  level_aigleTask: "Terreno empinado, gestiona el combustible",
  level_glacierName: "Pista Roja - Le Glacier",
  level_glacierTask: "Aprende a usar el cabrestante en pendiente",
  level_tubeName: "Halfpipe - Le Tube",
  level_tubeTask: "Prepara el halfpipe para la competición",
  level_verticaleName: "Pista Negra - La Verticale",
  level_verticaleTask: "Operación nocturna con cabrestante",
  level_colDangereuxName: "Zona de Avalanchas - Col Dangereux",
  level_colDangereuxTask: "Prepara la zona de alto riesgo",
  level_tempeteName: "Tormenta - Recuperación",
  level_tempeteTask: "Despeja las pistas tras la tormenta",
  level_coupeDesAiguillesName: "Coupe des Aiguilles - Final FIS",
  level_coupeDesAiguillesTask: "Prepara todas las pistas para la competición",
  
  // Hazards
  cliffFall: "⚠️ ¡CUIDADO! ¡Has caído al precipicio! Misión fallida.",
  fuelEmpty: "⛽ ¡SIN COMBUSTIBLE! Ni una gota de diésel...",
  // UNUSED avalancheZone: "ZONA DE AVALANCHAS",
  riskLevelHigh: "ALTO",
  avalancheWarning: "⚠️ ¡PELIGRO! ¡Manto de nieve inestable! ¡Sal de la zona!",
  avalancheTrigger: "🏔️💨 ¡AVALANCHA DESENCADENADA! ¡Evacuación imposible!",
  steepWarning: "⚠️ ¡PENDIENTE EMPINADA! ¡Usa el cabrestante ({winchKey}) o resbalarás!",
  steepWarningNoWinch: "⚠️ ¡PENDIENTE EMPINADA! ¡Frena y usa los caminos de servicio para rodear!",
  tumble: "🔄 ¡VUELCO! ¡La máquina ha volcado en la pendiente!",
  
  // Dialogues
  jeanPierreIntro: "Buen trabajo en el tutorial, chaval. Ahora va en serio — la Verde, con cronómetro y combustible que gestionar.",
  level_marmottesMid: "¿Ves ese brillo en las cumbres? Las primeras luces. Lo mejor de este trabajo — solo tú, la máquina y la montaña despertando.",
  level_chamoisIntro: "¡Hola, soy Émilie! JP te pone en la azul. Venga, demuestra que sabes hacer algo más que terciopelo en la verde.",
  level_airZoneIntro: "¡El snowpark es MI terreno — vamos a montarles algo increíble! Cada módulo tiene que estar perfecto, los riders cuentan con nosotros.",
  level_aigleIntro: "L'Aigle es serio. Vigila el combustible. Los caminos de pisapistas permiten subir — busca los postes con rayas amarillas y negras.",
  level_glacierIntro: "Hola, soy Thierry — jefe de seguridad. Le Glacier es empinado. He revisado cada anclaje. Pulsa {winchKey} junto a un poste para enganchar el cabrestante — y por favor, no lo sueltes.",
  level_glacierIntroTouch: "Hola, soy Thierry — jefe de seguridad. Le Glacier es empinado. He revisado cada anclaje. Toca el botón de cabrestante junto a un poste — y por favor, no lo sueltes.",
  level_tubeIntro: "¡Mañana es el contest en el Tube! Quiero paredes limpias, labio afilado y cero baches.",
  level_verticaleIntro: "Noche en La Verticale: pendiente fuerte, bordes peligrosos. Cabrestante obligatorio — usa los 3 anclajes y mantente en línea.",
  level_colDangereuxIntro: "Alto riesgo de avalancha en el Col — estamos en protocolo de seguridad de avalanchas activo. Evita las zonas sobrecargadas y respeta los límites.",
  level_tempeteIntro: "La tormenta ha pasado. ¡Toma un vin chaud, va a ser largo!",
  level_coupeDesAiguillesIntro: "Es la gran noche. La FIS inspecciona mañana. Cada pista debe ser perfecta — muéstrame lo que has aprendido.",
  marieWelcome: "Ven a calentarte a lo de Marie. ¡Una buena tartiflette!",
  marieIntro: "¡Hola! Soy Marie, llevo el restaurante de arriba. Pasa cuando quieras — ¡una comida caliente hace milagros aquí!",
  
  // Changelog
  changelog_20260219_date: "19 de febrero de 2026",
  changelog_20260219: "🎬 Prólogo para nuevos jugadores\n📖 Tutorial simplificado\n🌦️ Clima aleatorio en el menú\n🔗 Pistas del día compartibles\n🎥 Créditos cinematográficos",
  changelog_20260222_date: "22 de febrero de 2026",
  changelog_20260222: "🚩 Reequilibrio de puertas de slalom\n💬 Botón de feedback",
  changelog_20260223_date: "23 de febrero de 2026",
  changelog_20260223: "📲 Instala en tu dispositivo para jugar sin conexión",
  changelog_20260220_date: "20 de febrero de 2026",
  changelog_20260220: "🗺️ Mapa de pistas\n🎿 Terminología de estación",
  changelog_20260217_date: "17 de febrero de 2026",
  changelog_20260217: "🏔️ Siete formas de pista\n🎯 Variedad de pistas\n⚡ Descenso más fluido",
  changelog_20260216_date: "16 de febrero de 2026",
  changelog_20260216: "🎲 Pistas del día",
  changelog_20260215_date: "15 de febrero de 2026",
  changelog_20260215: "⚡ Mejora del renderizado nocturno\n📱 Botones táctiles en esquí\n⌨️ Detección de teclado",
  changelog_20260214_date: "14 de febrero de 2026",
  changelog_20260214: "🎪 Puntuación de trucos y combos\n🏂 Posición de huevo y física del halfpipe\n👁️ Mejor contraste de pistas\n📱 Preparación auto con cabrestante (táctil)\n♿ Modo alto contraste",
  changelog_20260213_date: "13 de febrero de 2026",
  changelog_20260213: "🚩 Puertas de eslalon\n🏔️ Saltos de esquí\n⚡ Rendimiento mejorado\n🎹 Música nocturna de piano\n🔊 Volumen del motor ajustable",
  changelog_20260212_date: "12 de febrero de 2026",
  changelog_20260212: "📋 Mapa de pistas\n🔗 Cable de cabrestante rompible\n🕹️ Diagnóstico del mando\n🍽️ Los platos de Marie\n❄️ Exposición al frío",
  changelog_20260211_date: "11 de febrero de 2026",
changelog_20260211: "⛷️ Descenso en esquí tras la preparación\n🎯 Calidad de preparación\n🏔️ Zonas empinadas coloreadas\n🏗️ Terrain park y trucos",
  changelog_20260210_date: "10 de febrero de 2026",
  changelog_20260210: "🎵 Música y efectos de sonido\n🔈 Ajustes de volumen\n⏱️ Tiempos de pista auto-calibrados\n⏭️ Saltar tutorial\n🏔️ Rediseño de zonas de avalancha",
  changelog_20260209_date: "9 de febrero de 2026",
  changelog_20260209: "🏔️ Pantallas victoria/derrota alpinas\n❄️ Acumulación de nieve en tormenta\n🏆 Bonus sin fallos\n🔊 Sonidos de clima y fauna",
  changelog_20260208_date: "8 de febrero de 2026",
  changelog_20260208: "📊 Nuevo panel de control\n🏔️ Le Glacier y Coupe des Aiguilles\n🦅 Fauna alpina\n🎨 Retratos de personajes\n🎮 Navegación con teclado y mando",
  changelog_20260207_date: "7 de febrero de 2026",
  changelog_20260207: "🎨 UI retro\n🎯 Objetivos bonus\n🕹️ Reasignación de botones\n🎮 Navegación con mando",
  changelog_20260206_date: "6 de febrero de 2026",
  changelog_20260206: "🛤️ Caminos de pisapistas transitables\n🕹️ Joystick virtual\n🌍 5 idiomas completos",
  changelog_20260205_date: "5 de febrero de 2026",
  changelog_20260205: "🏔️ Acantilados rocosos\n🌙 Faros nocturnos\n🔗 Mecánica cabrestante\n⌨️ Navegación teclado",
  changelog_20260204_date: "4 de febrero de 2026",
  changelog_20260204: "🎮 Soporte mando\n📱 Controles táctiles\n💪 Resistencia\n💾 Guardado\n♿ Accesibilidad",
  changelog_20260203_date: "3 de febrero de 2026",
  changelog_20260203: "🚜 Lanzamiento: 9 pistas, escuela de esquí\n❄️ Preparación, combustible, avalanchas\n🏆 Créditos y progresión",

  // Taunts - Cliff
  tauntCliff1: "9 toneladas en el barranco. Al seguro le va a encantar.",
  tauntCliff2: "Jean-Pierre dijo: '¡No tan cerca del borde!' ¿Recuerdas?",
  tauntCliff3: "El equipo de rescate baja con cuerdas. Otra vez.",
  tauntCliff4: "Marie cancela tu reserva de raclette para esta noche.",
  tauntCliff5: "Thierry ya está calculando los costes de reparación...",
  // Taunts - Fuel
  tauntFuel1: "El indicador llevaba 10 minutos en rojo. ¿Qué mirabas?",
  tauntFuel2: "Émilie escribió 'REPOSTAR' en mayúsculas en la pizarra.",
  tauntFuel3: "Hasta el diésel tiene límites. Tú también, al parecer.",
  tauntFuel4: "Jean-Pierre suspira. Envía a Thierry con un bidón.",
  tauntFuel5: "Sale el sol. La pista no está preparada. Llegan los esquiadores.",
  // Taunts - Time
  tauntTime1: "Primer telesilla en 3... 2... 1... Perdido.",
  tauntTime2: "Los esquiadores descubren tu pista. Con baches. Helada. Magnífica.",
  tauntTime3: "Jean-Pierre mira su reloj, luego a ti, luego a su reloj.",
  tauntTime4: "La FIS pregunta por qué el slalom está sobre nieve papa.",
  tauntTime5: "Oyes a los monitores explicar a los clientes que 'no es culpa suya'.",
  // Taunts - Tumble
  tauntTumble1: "El cabrestante no es decorativo. Es para pendientes así.",
  tauntTumble2: "Thierry contempla los daños. No dice nada. Es peor.",
  tauntTumble3: "Jean-Pierre te enseñó cómo anclarte. ¿Estabas dormido?",
  tauntTumble4: "Una PistenBully cuesta 400.000€. Bueno, costaba.",
  tauntTumble5: "¿La pendiente parecía manejable? La máquina no estaba de acuerdo.",
  featureDestroyedKicker: '¡Has pasado por encima de un módulo del park! El kicker está destruido.',
  featureDestroyedRail: '¡Has pasado por encima de un módulo del park! El rail está destruido.',
  tauntFeature1: 'Ese módulo costó tres horas. Lo aplanaste en tres segundos.',
  tauntFeature2: 'Émilie va a tener unas palabras contigo sobre ese módulo.',
  tauntFeature3: 'El equipo del park acaba de verte destruir su obra maestra.',
  tauntFeature4: 'Los módulos son para esquiadores, no para máquinas. ¡Rodéalos!',
  tauntFeature5: 'Un módulo menos para la competición de mañana.',
  bonusPipeMastery: 'Dominio del halfpipe',
  // Taunts - Avalanche
  tauntAvalanche1: "La montaña rara vez perdona. No perdonó.",
  tauntAvalanche2: "Météo France dijo nivel de riesgo 4. ¿Lo leíste?",
  tauntAvalanche3: "El rescate encontrará la máquina en primavera. Quizás.",
  tauntAvalanche4: "Marie oye la alerta por radio. Ya sabe que eres tú.",
  tauntAvalanche5: "El rescate había asegurado el sector. Tú lo dejaste sin asegurar.",

  // Taunts - Ski wipeout (fun, self-deprecating)
  tauntSkiWipeout1: "Caída estrepitosa. Equipo por todos lados, dignidad en ninguno.",
  tauntSkiWipeout2: "Al precipicio le dio igual tu técnica de esquí.",
  tauntSkiWipeout3: "El equipo de rescate ya se ríe. Lo vieron todo.",
  tauntSkiWipeout4: "Eso pasa por esquiar una pista que TÚ preparaste.",
  tauntSkiWipeout5: "Hasta los íbices hicieron una mueca con ese aterrizaje.",
  // Key names
  key_space: "ESPACIO",
  key_shift: "MAYÚS",
  key_ctrl: "CTRL",
  key_alt: "ALT",
  key_enter: "INTRO",
  key_tab: "TAB",
  key_esc: "ESC",
  key_del: "SUPR",
  dailyRuns: "Pistas del día",
  dailyRuns_dailyShift: "Turno diario",
  dailyRuns_randomRun: "Salida aleatoria",
  dailyRuns_rank: "Rango",
  dailyRuns_seed: "Semilla",
  // UNUSED   dailyRuns_start: "Iniciar contrato",
  dailyRuns_locked: "Completa todas las pistas para desbloquear",
  dailyRuns_lockedShared: "Completa todas las pistas para desbloquear las Carreras diarias y jugar esta pista compartida",
  // UNUSED   dailyRun_levelName: "Contrato",
  dailyRun_levelTask: "Prepara la pista hasta la cobertura objetivo",
  dailyRuns_briefing: "Informe",
  dailyRuns_target: "Objetivo",
  dailyRuns_timeLimit: "Tiempo",
  dailyRuns_weather_clear: "Cielo despejado",
  dailyRuns_weather_light_snow: "Nevada ligera",
  dailyRuns_weather_storm: "Condiciones de tormenta",
  dailyRuns_night: "Turno de noche",
  dailyRuns_day: "Turno de día",
  rank_green: "Verde",
  rank_blue: "Azul",
  rank_red: "Roja",
  rank_black: "Negra",
  rank_park: "Park",
  share: "Compartir",
  copied: "Enlace copiado!",
  playSharedSeed: "Carrera compartida",
  dailyRunBriefingJP: "Esta pista tiene que estar lista antes de que abran los remontes. A trabajar.",
  dailyRunBriefingThierry: "Ten cuidado ahí arriba — tramos empinados y nieve inestable. No te confíes.",
  dailyRunBriefingMarie: "Esta noche va a helar de lo lindo. Pásate por el restaurante a calentarte si lo necesitas.",
  dailyRunBriefingEmilie: "Otra pista más. ¡A ver si superas mi tiempo!"
};

export default es;
